module.exports = __webpack_public_path__ + "static/media/logo_lacost_textonly.0d5d4f02.png";